export type OfficeUtilityResumeTye = {
  [officeId: string]: {
    chargeExpenses: boolean,
    achieved: boolean,
    goal: number,
    total: number,
    userAtCampaign: number,
    dealedNumbers: number,
    avarageCostNumber: number,
    totalCostNumbers: number,
    copRegistered: number,
    copWorkers: number,
    copUtility: number,
    
    excludeWorkers: number,
    utilityAfterExcludes: number,
    rentCop: number,
    rentCopMonth: number,
    salaries: number,
    utilitBeforePartner: number,
    utilityNet: number,
    percentage: number,
    utilityLead: number,
    partnerPercentage: number,
    partnerUtility: number,
    leadPercentage: number,
    leadUtility: number,
    checked: boolean,
    
    [key: string]: any,
  }
}

export const emptyOfficeInit = {
  utilitBeforePartner: 0,
  chargeExpenses: true,
  achieved: false,
  goal: 0,
  total: 0,
  userAtCampaign: 0,
  dealedNumbers: 0,
  avarageCostNumber: 0,
  totalCostNumbers: 0,
  copRegistered: 0,
  copWorkers: 0,
  copUtility: 0,
  rentCop: 0,
  rentCopMonth: 0,
  salaries: 0,
  utilityNet: 0,
  percentage: 0,
  utilityLead: 0,
  checked: false,
  partnerPercentage: 0,
  partnerUtility: 0,
  leadPercentage: 0,
  leadUtility: 0,
  excludeWorkers: 0,
  utilityAfterExcludes: 0
}